
import {map} from 'rxjs/operators';
import { DB_KEY_PREFIXES } from './../../config/pouch-db.config';
import { DB_ALLDOCS_QUERY_OPTIONS } from '../../config/pouch-db.config';
import { Injectable, Injector } from "@angular/core";
import { SampleService } from "../../services/sample/sample.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable ,  forkJoin } from "rxjs";
import { Endpoints } from "../../../config/endpoints.config";
import { AuthenticationService, NUM_BUCKETS_PER_POSITION } from "../../services/authentication.service";
import { CaseManagementService } from "../../services/case-management/case-management.service";
import { CaseActivity } from "../../classes/case-intake/case-activity.class";
import { FeatureActionsMap } from "../../classes/authentication/user.class";
import { DeviceService } from "../../services/device/device.service";
import { DiskService } from "../../services/disk/disk.service";
import { DB_SYNC_STATE_KEYS } from "../../config/pouch-db.config";
import { EntitySyncInfo, EntityNames, DeltaService } from "../delta/delta.service";
import { EventsService } from "../../services/events/events.service";
import { Account } from '../../classes/account/account.class';
import { Contact } from '../../classes/contact/contact.class';
import { GlobalUtilityService } from '../../services/global-utility.service';
import { CaseCategory } from '../../classes/case-intake/case-utility.class';
import { UIService } from '../../services/ui/ui.service';
import { AccountOfflineService } from '@omni/services/account/account.offline.service';
import { ContactOfflineService, getBucketId } from '@omni/services/contact/contact.service';
import { LoadingController } from '@ionic/angular';
import { LogService } from "../../services/logging/log-service";
import { GlobalErrorHandler } from "../../services/error-handler/error-handler-service";
import { Utility } from '@omni/utility/util';
import { isEmpty } from 'lodash-es';

const { dataPartitioner } = require('../../../assets/workers/data-partitioner-worker.js');

@Injectable({
  providedIn: 'root'
})
export class CaseManagementDataService {

    constructor(
        private eventService: EventsService,
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        private caseManagementService: CaseManagementService,
        private deviceService: DeviceService,
        private disk: DiskService,
        private deltaService: DeltaService,
        private globalUtility: GlobalUtilityService,
        private uiService: UIService,
        private accountService: AccountOfflineService,
        private contactService: ContactOfflineService,
        private loadingCtrl: LoadingController,
        private logService: LogService,
        private errorHandler: GlobalErrorHandler,
        private injector: Injector,
    ) {

    }

    public async initCaseService(loadFromDBOnly = false) {
        if (this.authenticationService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
            Promise.all([
                this.fetchCaseCategory(loadFromDBOnly),
                this.fetchResponsePreference(loadFromDBOnly),
            ]);
        }
      if (this.authenticationService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE) || this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER_SCAN_TOOL) || this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER_ASSESS) || this.authenticationService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_COMPETITOR_DATA) || this.authenticationService.user.buConfigs['indskr_competitorproduct']
        || this.authenticationService.hasFeatureAction(FeatureActionsMap.ALLOCATION_ORDERS_UNRESTRICTED) || this.authenticationService.hasFeatureAction(FeatureActionsMap.SAMPLE_RECONCILIATIONS) || this.authenticationService.hasFeatureAction(FeatureActionsMap.SAMPLE_DELIVERY_REQUESTS)
        || this.authenticationService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL) // OMNI-61611: banners need the payload under plain allocation tool too
        || this.authenticationService.hasFeatureAction(FeatureActionsMap.RX_TRENDS)) {
          await this.fetchCaseProducts(loadFromDBOnly)
        }
    }

    public async fetchCaseCategory(loadFromDBOnly = false) {
        if (!this.authenticationService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
            return;
        }
        if (!(this.deviceService.isOffline || loadFromDBOnly)) {
        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.FETCH_EXPERT_CATEGORIES;
        return this.http.get(url).pipe(map(
            async (res: any) => {
                console.log(res);
                await this.caseManagementService.storeCaseType(res);
                this.disk.updateOrInsert(DB_KEY_PREFIXES.EXPERT_CATEGORIES, doc => ({ raw: res }));
            },
            async err => {
                console.log(err);
                console.log("error handling");
            })).toPromise();
        } else if (loadFromDBOnly) {
            const dbData = await this.disk.retrieve(DB_KEY_PREFIXES.EXPERT_CATEGORIES, true);
            if (dbData) {
                await this.caseManagementService.storeCaseType(dbData.raw);
            }
        }
    }

    public async fetchResponsePreference(loadFromDBOnly = false) {
        if (!this.authenticationService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
            return;
        }
        if (!(this.deviceService.isOffline || loadFromDBOnly)) {
        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.FETCH_RESPONSE_PREFERENCE;
        return this.http.get(url).pipe(map(
            async (res: any) => {
                console.log(res);
                await this.caseManagementService.storeResponsePreferences(res);
                this.disk.updateOrInsert(DB_KEY_PREFIXES.RESPONSE_PREFERENCE, doc => ({ raw: res }));
            },
            async err => {
                console.log(err);
                console.log("error handling");
            })).toPromise();
        } else if (loadFromDBOnly) {
            const dbData = await this.disk.retrieve(DB_KEY_PREFIXES.RESPONSE_PREFERENCE, true);
            if (dbData) {
                await this.caseManagementService.storeResponsePreferences(dbData.raw);
            }
        }
    }

    public async createCaseOnline(data: CaseActivity) {
        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.CREATE_CASE;
        console.log(data.createCaseDTO);
        let response = await this.http.post(url, data.createCaseDTO).toPromise();
         // update for interaction
        let dbAccounts = await this._updateInteractionsForAccounts(data);

        if(data.createCaseDTO['customerid'] && !isEmpty(data.createCaseDTO['customerid'])){
          let dbContacts = await this.updateInteractionsForContacts(data);
        }
        
        if (!isEmpty(dbAccounts)) {
          await this.disk.saveAccountsToDB(dbAccounts, this.authenticationService.get_num_buckets());
        }        
       
        return response;
    }

  private async updateInteractionsForContacts(data: CaseActivity) {
    const bucketID = getBucketId(data._case_contact.ID, this.authenticationService.get_num_buckets());

    let dbContacts = [];

    const dbKey = Utility.getDBBucketedKey(DB_KEY_PREFIXES.CONTACT, bucketID)

    let rawContactsDoc: any = await this.disk.retrieve(dbKey);

    if (rawContactsDoc && rawContactsDoc.raw && Array.isArray(rawContactsDoc.raw)) {
      
      dbContacts = rawContactsDoc.raw;
    }

    dbContacts = this.globalUtility.updateInteractionContact(data._case_contact, 'Inquiries', dbContacts);

    if (!isEmpty(dbContacts)) {
      this.disk.updateOrInsert(dbKey, doc => ({ raw: dbContacts }));
    }

    return dbContacts;
  }

  private async _updateInteractionsForAccounts(data: CaseActivity) {
    let dbAccounts = [];
    dbAccounts = await this._getAccountsArrayFromDB();
    dbAccounts = this.globalUtility.updateInteractionAccount(data._case_account, 'Inquiries', dbAccounts);
    return dbAccounts;
  }

  private async _getAccountsArrayFromDB(): Promise<any[]> {
    const batches = await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_ACCOUNTS);
    if (!Array.isArray(batches) || batches.length === 0) return [];
    return batches.reduce((acc: any[], el: any) => {
      if (Array.isArray(el?.raw)) acc.push(...el.raw);
      return acc;
    }, []);
  }

    public async fetchCaseById(id) {
        if (!this.authenticationService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
            return;
        }

        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.DELTA_FETCH_CASES_BY_ID.replace('{CASE_ID}', id);

        url += '?lastUpdatedTime=' + new Date().setHours(0, 0, 0, 0);

        return this.http.get(url).toPromise();
    }

    public async fetchCaseProducts(loadFromDBOnly = false) {
        if (!(this.deviceService.isOffline || loadFromDBOnly)) {
        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.FETCH_PRODUCT_SKU;
        const positions = this.authenticationService.user.positions.map((o) => {
            return o.ID
        })
        url = url.replace('{{positionIDs}}', positions.toString());
        return this.http.get(url).pipe(map(
            async (res: any) => {
                console.log(res);
                await this.caseManagementService.mapSkuProduct(res);
                this.disk.updateOrInsert(DB_KEY_PREFIXES.CASE_PRODUCTS, doc => ({ raw: res }));
                // OMNI-61611: (re)download per-brand banner images every sync from
                // the same brandskuproducts payload (allocation feature only).
                if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL)) {
                    await this.injector.get(SampleService).downloadProductBanners(res);
                }
            },
            async err => {
                console.log(err);
                console.log("error handling");
            })).toPromise();
        } else if (loadFromDBOnly) {
            const dbData = await this.disk.retrieve(DB_KEY_PREFIXES.CASE_PRODUCTS, true);
            if (dbData) {
                await this.caseManagementService.mapSkuProduct(dbData.raw);
            }
            // OMNI-61611: offline / DB-only — load cached banner records.
            if (this.authenticationService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL)) {
                await this.injector.get(SampleService).loadProductBanners();
            }
        }
    }

    public async findCaseById(id) {

      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.FETCH_CASE_BY_ID.replace('{CASE_ID}', id);

      return this.http.get(url).toPromise();
    }

    public async getTeamCasesOnline():Promise<any>{
      let headers = new HttpHeaders();
      headers = headers.set('Sync-Service', 'true');
      headers = headers.set('X-SystemUserId', this.authenticationService.user.xSystemUserID);
      const positions = this.authenticationService.user.positions.map((o) => {
        return o.ID
      })
      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.activites.GET_TEAM_ACTIVITIES_FOR_TOOLS_BY_ACTIVITY_TYPES;
      const dataRange = this.authenticationService.getFromToDateRangeInUTCMiliSec(undefined);
      url = url.replace('{startDate}', dataRange.from);
      url = url.replace('{endDate}', dataRange.to);
      //url = url.replace('{activityTypes}', 'case');
      url = url.replace('{teamActivity}', 'teamCase');
      url = url.replace('{positionIDs}', positions.toString());
      try {
        const response =  await this.http.get(url, { headers }).toPromise();
        if(response && response['teamCases'] && Array.isArray(response['teamCases'])){
          this.caseManagementService.teamCases = [];
          response['teamCases'].forEach(rawTeamCase=> {
            /* Pouch db doesnt allow to store keyword starting with _ */
            for (let key in rawTeamCase) {
              if (key.charAt(0) === "_") {
                  var a = key.substring(1, key.length);
                  rawTeamCase[a] = rawTeamCase[a] = rawTeamCase[key];
                  delete rawTeamCase[key];
                  delete rawTeamCase[key];
              }
            }
            const teamC = new CaseActivity(rawTeamCase);
            this.caseManagementService.teamCases.push(teamC);
          })
          this.caseManagementService.reMapTeamDataWithValues(this.accountService.accounts, this.contactService.contacts,this.caseManagementService.teamCases);
        }
      } catch (error) {
        console.log('Fetch Team Cases for Tool Error: '+error)
      }
      return;
    }

    // public async updateKitBookings(activity: CaseActivity, setBookings): Promise<boolean> {
    //   let isSuccess: boolean = true;
    //   let loader = await this.loadingCtrl.create();
    //   loader.present();
    //   let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.casemanagement.UPDATE_CASE_SETBOOKING.replace('{CASE_ID}', activity.ID);
  
    //   let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    //   headers.headers = headers.headers.set(
    //     "X-PositionId",
    //     this.authenticationService.user.xPositionID
    //   );
  
    //   try {
    //     let response = await this.http
    //       .put(url,setBookings , headers) // send only the required payload
    //       .toPromise();
    //     this.logService.logDebug(response);
    //     loader.dismiss();
    //   } catch (e) {
    //     isSuccess = false;
    //     this.errorHandler.handleError(e);
    //     loader.dismiss();
    //   }
  
    //   try { // I/O operations needs to be wrap in a try and catch block
    //     this.caseManagementService.upsertMyCases(activity); // offline saving
    //     loader.dismiss();
    //   } catch (e) {
    //     console.error('Caught error trying to save products and key messages offline', e);
    //     isSuccess = false;
    //     loader.dismiss();
    //   }
    //   return isSuccess;
    // }

}
